import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import IconButton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/IconButton';
import CancelIcon from '@material-ui/icons/Cancel';

const styles = () => ({
  root: {},
});

const CloseButton = ({
  className,
  classes,
  onClose,
}) => {
  return (
    <IconButton
      aria-label="close"
      className={classNames(classes.root, className)}
      color="primary"
      icon={CancelIcon}
      onClick={onClose}
      title="Close"
    />
  );
};

CloseButton.defaultProps = {
  className: '',
};

CloseButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default withStyles(styles)(CloseButton);
